//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import bottom from '@/assets/img/bottom.png'
import {getUrlparams, countDownTimeFunc, toCopy} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import {Dialog, Toast} from 'vant';
import VanDatePicker from '@/components/datePicker';
import homeTip from '@/components/homeTip'

export default {
  name: "qualityReport",
  components: {
    footerNav,
    VanDatePicker,
    homeTip
  },
  data() {
    return {
      bottom,
      showPopup: false,
      value: '',
      toCopy,
      searchValue: '',
      loading: false,
      finished: false,
      refreshing: false,
      reportList: [],
      checkAll: false,
      showPicker: false,
      value: '',
      currentDate: new Date(),
      startDate: '',
      endDate: '',
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
    document.scrollingElement.scrollTop = 0
  },
  methods: {
    onSearch() {
      this.reportList = [];
      this.onLoad()
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var params = {
        "start": this.reportList.length,
        "size": 10,
        "orderKey":"reportDate",
        "desc":true
      }
      if(this.startDate){
        params.startDate = this.startDate
      }
      if(this.endDate){
        params.endDate = this.endDate
      }
      axiosApi.queryQualityOrderReportMsg(params).then(response => {
        if (response.content && response.content.list && response.content.list.length > 0) {
          response.content.list.forEach((item) => {
            item.list = item.passList.concat(item.noPassList)
            var str = (item.deptName?item.deptName:'')+'今日进检'+item.passList.concat(item.noPassList).length+'批\n';
            if(item.passList&&item.passList.length>0){
              item.passList.forEach((item1)=>{
                str+=item1.spuCode+'('+item1.colorValueAll+')\n'
              })
              str += '合格\n';
            }
            if(item.noPassList&&item.noPassList.length>0){
              item.noPassList.forEach((item1)=>{
                str+=item1.spuCode+'('+item1.colorValueAll+')\n'
              })
              str += '不合格\n';
            }
            item.copyStr = str
          })
          this.reportList = this.reportList.concat(response.content.list)
        }
        this.loading = false;
        this.refreshing = false;
        if (this.reportList.length == response.content.total) {
          this.finished = true;
        }
      })
    },
    onConfirm(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      this.startDate = value.slice(0,3).join('-');
      this.endDate = value.slice(4,7).join('-');
      this.value = this.startDate + '至' + this.endDate;
      this.showPicker = false
    },

    onChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
    },
    toSome(row) {
      this.$router.push({name: 'someQualityDetail', query: {data: JSON.stringify(row)}})
    },
    toDetail() {
      this.$router.push({name: 'qualityOrderDetail'})
    },
    showCheck(item) {
      if (item.qualityResultId) {
        this.$router.push({
          name: 'qualityWrite',
          query: {qualityResultId: item.qualityResultId, qualityOrderId: item.qualityOrderId}
        })
      } else if (item.qualityOrderDetailList.length == 1) {
        this.$router.push({name: 'qualityWrite', query: {data: JSON.stringify([item])}})
      } else if (item.qualityOrderDetailList.length > 1) {
        item.qualityOrderDetailList.forEach((item) => {
          item.choose = false
        })
        this.list = item.qualityOrderDetailList
        this.showPopup = true
      }
    },
    chooseConfirm() {
      var list = this.list.filter((item) => {
        return item.choose == true
      })
      if (list.length == 0) {
        Toast.fail('请选择');
        return
      } else {
        this.$router.push({name: 'qualityWrite', query: {data: JSON.stringify(list)}})
      }
    },
    chooseAll() {
      let a = this.checkAll;
      this.list = this.list.map(e => {
        e.choose = a;
        return e;
      });
    },
    choose() {
      let a = true;
      this.list.forEach(e => {
        if (e.choose === false) {
          a = false;
        }
      });
      console.log(a)
      this.checkAll = a;
    },
    clickBtn() {
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作',
      })
        .then(() => {
          Toast.success('成功');

        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
    toAudit(item) {
      this.$router.push({name: 'qualityAudit', query: {qualityOrderId: item.qualityOrderId}})
    },
    backSubmit(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作？',
      })
        .then(() => {
          var queryParams = {qualityOrderIdList: [item.qualityOrderId]}
          axiosApi.clearQualityOrderResult(queryParams).then(response => {
            Toast.success('操作成功');
            this.onSearch()
          }).catch(error => {
          })
        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
    backAudit(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作?如质检单采购审核已生成全检单或返工单,需操作作废!',
      })
        .then(() => {
          var queryParams = {qualityOrderIdList: [item.qualityOrderId]}
          axiosApi.unAuditQuality(queryParams).then(response => {
            Toast.success('操作成功');
            this.onSearch()
          }).catch(error => {
          })
        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
    deleteRow(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认作废？',
      }).then(() => {
        var queryParams = {qualityOrderStatus: -1, qualityOrderIdList: [item.qualityOrderId]}
        axiosApi.cancelQualityOrder(queryParams).then(response => {
          Toast.success('操作成功');
          this.onSearch()
        }).catch(error => {
        })
      }).catch(() => {
        Toast.fail('已取消');
      });
    },
    toReport(){

    },
    sendReport(){
      axiosApi.genQualityOrderReportMsg({}).then(response => {
        Toast.success('操作成功');
      }).catch(error => {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/qualityReport.vue